import _ from 'lodash';
import { bookingConstants, bookingStatus, bookingOptions, isBookForMyself } from 'utils/constants/booking-constants';
import { cartConstants } from 'services/redux/cart/constants';

export const collectTimeslotCapacity = ( object, timeslotCapacity, cart ) => {
	const _bookingExternalPersons = cart[ cartConstants.BOOKING_EXTERNAL_PERSONS ];
	const _cartBookingCoworkers = cart[ cartConstants.BOOKING_COWORKERS ];

	let employeeBookingStatus = _.get( object, 'status', null );
	let isInvitation = timeslotCapacity.is_invitation === 'yes';
	let isInvited = timeslotCapacity.employee_is_invited === 'yes';

	// Extra check
	// Only do this when it is created by timeslot (not by booking)
	// ONLY when the employee IS invited set it
	if( _.get( object, 'is_timeslot', false ) === true ) {
		if( timeslotCapacity?.employee_is_invited === 'yes' ) {
			employeeBookingStatus = timeslotCapacity.employee_booking_status;
		}
	}

	// Now check if the employee is also the inviter
	const isInviter = timeslotCapacity.is_inviter === 'yes';
	const employeeBookingStatusInvited = (employeeBookingStatus === bookingStatus.INVITED);

	// Is it already booked?
	const isTimeslotBooked = timeslotCapacity.bookings > 0;

	// Get the total places available
	const placesAvailable = ( timeslotCapacity.capacity === -1 ) ? 1000 : ( timeslotCapacity.remaining );

	// Check if the employee did already book
	const employeeDidAlreadyBook = timeslotCapacity.employee_did_book === 'yes';

	// Amounts
	const bookForMyself = isBookForMyself( cart[ cartConstants.BOOK_FOR_OPTION ] );
	const bookForMultiple = [ bookingOptions.MYSELF_AND_COWORKERS, bookingOptions.COWORKERS ].includes( cart[ cartConstants.BOOK_FOR_OPTION ] );

	const defaultEmployeeAmount = bookForMyself ? 1 : 0;

	// Get the 'extra' persons selected
	const personsSelectedSize = _.size( _bookingExternalPersons ) + _.size( _cartBookingCoworkers );

	// Default amount = 1 plus the extra selected
	let personAmount = (defaultEmployeeAmount + personsSelectedSize);

	// When booking for multiple people and current employee did already book? Do the amount minus the current employee
	if( bookForMultiple && employeeDidAlreadyBook ) {
		personAmount -= defaultEmployeeAmount;
	}

	// Check if there are enough places available -> when invited there are always enough
	const enoughPlacesAvailable = ( isInvited ) || ( placesAvailable >= personAmount );

	let isTimeslotAvailable;
	switch( object?.kind ) {
		case bookingConstants.MEETING_ROOM:
			// Not an invitation?
			if( isInvitation ) {
				// Check if we are invited
				isTimeslotAvailable = bookForMyself && isInvited;
			} else {
				// And already booked? Then it is full...
				//// Except: when the employee did already book this one
				isTimeslotAvailable = ( !isTimeslotBooked || ( bookForMyself && employeeDidAlreadyBook && enoughPlacesAvailable ) );
			}
			break;

		default:
			if( isInvitation ) {
				// Check if we are invited
				isTimeslotAvailable = isInvited;
			} else {
				isTimeslotAvailable = enoughPlacesAvailable
			}
	}

	return {
		timeslotCapacity,

		isTimeslotBooked,
		isInvitation,
		isInviter,
		isInvited,
		isTimeslotAvailable,

		placesAvailable,
		employeeDidAlreadyBook,
		employeeBookingStatus,
		employeeBookingStatusInvited,

		bookForMyself,
		bookForMultiple,
		defaultEmployeeAmount,

		personsSelectedSize,
		personAmount,
		enoughPlacesAvailable
	}
};
